export default "__VITE_ASSET__cdf39bf4__"